import { FieldTypes } from "pages/employer-of-record/components/AutoForm";
import { array, countryIs, field, REQUIRED } from "./utils";
import * as PERU from "pages/employer-of-record/onboarding/profile-info/form/pe/constants.pe";
import { NATIONALITIES } from "pages/employer-of-record/onboarding/profile-info/constants";

const familyMemberType = field({
  type: FieldTypes.select,
  informationType: "identification",
  name: "familyMemberType",
  label: "Tipo Pariente (Family Member)",
  placeholder: "Select Family Member Type",
  options: PERU.FAMILY_MEMBER_OPTIONS,
  validations: REQUIRED,
  scenarios: {
    onboarding: countryIs("PE"),
  },
  value: () => "",
});

const lastName = field({
  type: FieldTypes.text,
  informationType: "identification",
  name: "lastName",
  label: "Apellido (Last Name)",
  validations: REQUIRED,
  scenarios: {
    onboarding: countryIs("PE"),
  },
  value: () => "",
});

const middleName = field({
  type: FieldTypes.text,
  informationType: "identification",
  name: "middleName",
  label: "Segundo Nombre (Middle Name)",
  validations: REQUIRED,
  scenarios: {
    onboarding: countryIs("PE"),
  },
  value: () => "",
});

const name = field({
  type: FieldTypes.text,
  informationType: "identification",
  name: "name",
  label: "Nombre (Name)",
  validations: REQUIRED,
  scenarios: {
    onboarding: countryIs("PE"),
  },
  value: () => "",
});

const birthDate = field({
  type: FieldTypes.date,
  informationType: "identification",
  name: "birthDate",
  label: "Fecha Nacimiento (Birth Date)",
  validations: REQUIRED,
  scenarios: {
    onboarding: countryIs("PE"),
  },
  value: () => "",
});

const gender = field({
  type: FieldTypes.select,
  informationType: "identification",
  name: "gender",
  label: "Sexo (Gender)",
  placeholder: "Select Gender",
  options: PERU.GENDER_OPTIONS,
  validations: REQUIRED,
  scenarios: {
    onboarding: countryIs("PE"),
  },
  value: () => "",
});

const idType = field({
  type: FieldTypes.select,
  informationType: "identification",
  name: "idType",
  label: "Tipo Doc Identidad (National ID Type)",
  placeholder: "Select ID Type",
  options: PERU.ID_TYPE_OPTIONS,
  validations: REQUIRED,
  scenarios: {
    onboarding: countryIs("PE"),
  },
  value: () => "",
});

const idNumber = field({
  type: FieldTypes.text,
  informationType: "identification",
  name: "idNumber",
  label: "Numero Doc Identidad (National ID Number)",
  validations: REQUIRED,
  scenarios: {
    onboarding: countryIs("PE"),
  },
  value: () => "",
});

export const peruFields = {
  peGender: field({
    type: FieldTypes.select,
    informationType: "identification",
    name: "peGender",
    label: "Sexo (Gender)",
    placeholder: "Select Gender",
    message:
      "For the time being, we are limited to these two options. We recognize that life is more nuanced and are actively exploring ways to fully reflect everyone's experiences.",
    options: PERU.GENDER_OPTIONS,
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("PE"),
    },
    value: () => "",
  }),
  peHealthInsuranceType: field({
    type: FieldTypes.select,
    informationType: "benefits",
    name: "peHealthInsuranceType",
    label: "Tipo de Seguro de Salud (Health Insurance Type)",
    placeholder: "Select Health Insurance Type",
    options: PERU.HEALTH_INSURANCE_OPTIONS,
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("PE"),
    },
    value: () => "",
  }),
  peMaritalStatus: field({
    type: FieldTypes.select,
    informationType: "identification",
    name: "peMaritalStatus",
    label: "Estado Civil (Marital Status)",
    placeholder: "Select Marital Status",
    options: PERU.MARITAL_STATUS_OPTIONS,
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("PE"),
    },
    value: () => "",
  }),
  peCountryOfBirth: field({
    type: FieldTypes.select,
    informationType: "identification",
    name: "peBirthCountry",
    label: "Pais Nacimiento (Country of Birth)",
    placeholder: "Select Country of Birth",
    options: NATIONALITIES,
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("PE"),
    },
    value: () => "",
  }),
  pePlaceOfBirth: field({
    type: FieldTypes.text,
    informationType: "identification",
    name: "peBirthPlace",
    message: "Please enter the place of birth as it appears in your passport.",
    label: "Lugar De Nacimiento (Place of Birth)",
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("PE"),
    },
    value: () => "",
  }),
  pePensionFund: field({
    type: FieldTypes.select,
    informationType: "pension",
    name: "pePensionFund",
    label: "Codigo AFP (Pension Fund)",
    placeholder: "Select Pension Fund",
    options: PERU.PENSION_FUND_OPTIONS,
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("PE"),
    },
    value: () => "",
  }),
  peAfpNumber: field({
    type: FieldTypes.text,
    informationType: "pension",
    name: "pePensionFundNumber",
    label: "Numero AFP (AFP Number)",
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("PE"),
    },
    value: () => "",
    hideWhen: {
      pePensionFund: (value) => value === "no_pension",
    },
  }),
  peIdType: field({
    type: FieldTypes.select,
    informationType: "identification",
    name: "peIdType",
    label: "Tipo Doc Identidad (National ID Type)",
    placeholder: "Select ID Type",
    options: PERU.ID_TYPE_OPTIONS,
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("PE"),
    },
    value: () => "",
  }),
  peIdNumber: field({
    type: FieldTypes.text,
    informationType: "identification",
    name: "peIdNumber",
    label: "Numero Doc Identidad (National ID Number)",
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("PE"),
    },
    value: () => "",
  }),
  peDependentInfos: array({
    type: FieldTypes.object,
    informationType: "identification",
    name: "peDependentInfos",
    label: "Personas a cargo (Dependents)",
    array: {
      limit: 10,
      deletionStrategy: "any",
      showFirstItem: false,
      itemLabelSuffix: "Dependent",
    },
    fields: [
      familyMemberType,
      lastName,
      middleName,
      name,
      birthDate,
      gender,
      idType,
      idNumber,
    ],
    scenarios: {
      onboarding: countryIs("PE"),
    },
    value: () => [],
  }),
};
